import axios from 'axios'
import config from './index'

const instance = axios.create({
    baseURL : config.url
})

export default instance;